module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_c('div', {
    staticClass: "pl10 pr10 mt20"
  }, [(_vm.infoData.schedule) ? _c('div', {
    staticClass: "pl10 mt20 mb20"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("审核进展：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.infoData.schedule.time * 1000)) + "  " + _vm._s(_vm.infoData.schedule.desc))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [(_vm.infoData.schedule.content) ? _c('div', {
    staticClass: "grid-content"
  }, [_vm._v("\n                    (" + _vm._s(_vm.infoData.schedule.content) + ")")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "ml20"
  }, [_vm._v("扩充分类基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "mt20 ml20"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "扩充分类编号："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.brandSupplementCode) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌品类申请编号："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.brandAgreementCode) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关联供应商合同编号："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.contractCode) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商编号："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.supplierCode) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.supplierName) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合作方式："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.infoData.cooperationTypeDesc) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算主体："
    }
  }, [(_vm.infoData.settlementBodyId == 1) ? _c('span', [_vm._v("北京果敢时代科技有限公司")]) : _vm._e(), _vm._v(" "), (_vm.infoData.settlementBodyId == 2) ? _c('span', [_vm._v("MAMA HONG KONG")]) : _vm._e(), _vm._v(" "), (_vm.infoData.settlementBodyId == 3) ? _c('span', [_vm._v("天津果敢时代国际贸易有限公司")]) : _vm._e(), _vm._v(" "), (_vm.infoData.settlementBodyId == 4) ? _c('span', [_vm._v("正合奇胜（天津）企业咨询管理有限公司")]) : _vm._e(), _vm._v(" "), (_vm.infoData.settlementBodyId == 5) ? _c('span', [_vm._v("老师线下打款")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同有效期："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("time")(_vm.infoData.startTime)) + "至" + _vm._s(_vm._f("time")(_vm.infoData.endTime)) + "\n                ")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "ml20"
  }, [_vm._v("品牌品类信息")]), _vm._v(" "), _c('div', {
    staticClass: "mt20 clearfix"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.infoData.brandApplies,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "74",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌中文名称",
      "min-width": "80",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": '#/common_detail?brandApplyId=' + scope.row.brandApplyId,
            "target": "_blank"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v(_vm._s(scope.row.brandName))])], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brandEnname",
      "label": "品牌英文名称",
      "min-width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "合作品类",
      "min-width": "120",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.categories), function(val) {
          return _c('div', {
            staticClass: "bor_style"
          }, [_vm._v("\n                            " + _vm._s(val.category.grandName) + "-" + _vm._s(val.category.parentName) + "-" + _vm._s(val.category.childrenName) + "\n                        ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": '/supple_brand_detail' + '?brandApplyId=' + scope.row.brandApplyId + '&brandAgreementId=' + _vm.id
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          }
        }, [_vm._v("查看")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt20 mb20",
    attrs: {
      "align": "center"
    }
  }, [(_vm.auth.saleAudit) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.rejectBtn(2)
      }
    }
  }, [_vm._v("驳回")]) : _vm._e(), _vm._v(" "), (_vm.auth.saleAudit) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitBtn(2)
      }
    }
  }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (_vm.auth.push && _vm.auth.edit) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.reback
    }
  }, [_vm._v("返回")]) : _vm._e(), _vm._v(" "), (_vm.auth.push && _vm.auth.edit) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.pushSupplier()
      }
    }
  }, [_vm._v("推送供应商")]) : _vm._e(), _vm._v(" "), (_vm.auth.inspectorAudit) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.rejectBtn(3)
      }
    }
  }, [_vm._v("驳回")]) : _vm._e(), _vm._v(" "), (_vm.auth.inspectorAudit) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitBtn(3)
      }
    }
  }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (_vm.auth.forensicAudit) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.rejectBtn(4)
      }
    }
  }, [_vm._v("驳回")]) : _vm._e(), _vm._v(" "), (_vm.auth.forensicAudit) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitBtn(4)
      }
    }
  }, [_vm._v("通过")]) : _vm._e(), _vm._v(" "), (_vm.auth.financeAudit) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.rejectBtn(5)
      }
    }
  }, [_vm._v("驳回")]) : _vm._e(), _vm._v(" "), (_vm.auth.financeAudit) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitBtn(5)
      }
    }
  }, [_vm._v("通过")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1be5aae1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/info_manage/brand_supple_agree/supple_audit_brand.vue
// module id = 499
// module chunks = 0